import React from 'react';

import {
    VirtualizedTableColumnType,
    VirtualizedTableItemKey,
    VirtualizedTableColumnKey
} from 'services/virtualizedTable/types';

import VirtualizedTableDateValue from '../VirtualizedTableDateValue';
import VirtualizedTableItemValue from '../VirtualizedTableItemValue';
import VirtualizedTableItemListValueCount from '../VirtualizedTableItemListValueCount';
import VirtualizedTableColumnOptionText from '../VirtualizedTableColumnOptionText';
import VirtualizedTableColumnOptionsText from '../VirtualizedTableColumnOptionsText';
import VirtualizedTableEntityList from '../VirtualizedTableEntityList';
import VirtualizedTableConfirmationCheckboxIcon from '../VirtualizedTableConfirmationCheckboxIcon';
import {
    FIELD_TYPE_DROPDOWN,
    FIELD_TYPE_DROPDOWN_MULTIPLE,
    FIELD_TYPE_DATE,
    FIELD_TYPE_CONFIRMATION_CHECKBOX,
    FIELD_TYPE_LIST,
    FIELD_TYPE_ENTITY_LIST
} from '../../constants';

interface Props {
    columnType?: VirtualizedTableColumnType;
    itemKey: VirtualizedTableItemKey;
    columnKey: VirtualizedTableColumnKey;
}

const VirtualizedTableCellValueComponent = (
    props: Props
): React.ReactElement | null => {
    const { columnType, itemKey, columnKey } = props;

    switch (columnType) {
        case FIELD_TYPE_DROPDOWN:
            return (
                <VirtualizedTableColumnOptionText
                    itemKey={itemKey}
                    columnKey={columnKey}
                />
            );
        case FIELD_TYPE_DROPDOWN_MULTIPLE:
            return (
                <VirtualizedTableColumnOptionsText
                    itemKey={itemKey}
                    columnKey={columnKey}
                />
            );
        case FIELD_TYPE_DATE:
            return (
                <VirtualizedTableDateValue
                    itemKey={itemKey}
                    columnKey={columnKey}
                />
            );
        case FIELD_TYPE_CONFIRMATION_CHECKBOX:
            return (
                <VirtualizedTableConfirmationCheckboxIcon
                    itemKey={itemKey}
                    columnKey={columnKey}
                />
            );
        case FIELD_TYPE_LIST:
            return (
                <VirtualizedTableItemListValueCount
                    itemKey={itemKey}
                    columnKey={columnKey}
                />
            );
        case FIELD_TYPE_ENTITY_LIST:
            return (
                <VirtualizedTableEntityList
                    itemKey={itemKey}
                    columnKey={columnKey}
                />
            );
        default:
            return (
                <VirtualizedTableItemValue
                    itemKey={itemKey}
                    columnKey={columnKey}
                />
            );
    }
};

export default VirtualizedTableCellValueComponent;
